<template>
  <ul>
    <li v-for="item in subsetList" :key="item.id"
        class="title-li" :class="{treeActive: current === item.id}">
      <div class="title-tr">
        <div class="title-left">
          <span v-if="item.subsetList.length===0" @click="propGoDirectory(item.id)">{{item.title}}</span>
          <span v-else>{{item.title}}</span>
        </div>
        <div class="title-right"  v-if="item.subsetList.length>0" @click="toggle(item)">
          <img src="@/assets/img/down.png" alt="" class="icon-up" v-if="item.show">
          <img src="@/assets/img/up.png" alt="" class="icon-up" v-else>
        </div>
      </div>
      <tree-menu :subsetList='item.subsetList' v-if="!item.show" :current="current" @change="changeCurrent" class="children"></tree-menu>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'treeMenu',
  props: ['subsetList', 'current'],
  components: {},
  data () {
    return {
      isShow: false
    }
  },
  computed: {
  },
  methods: {
    toggle (item) {
      var idx = this.subsetList.indexOf(item)
      this.$set(this.subsetList[idx], 'show', !item.show)
    },
    //  通过总线将值传给父组件
    propGoDirectory (id) {
      this.$emit('change', id)
    },
    changeCurrent (id) {
      this.propGoDirectory(id)
    }
  },
  created () {
    this.subsetList.forEach(item => {
      var idx = this.subsetList.indexOf(item)
      this.$set(this.subsetList[idx], 'show', !item.show)
    })
  }
}
</script>

<style scoped>
.tree_container ul li{
  height:.73rem;
  line-height:.73rem;
  border-bottom:1px solid #DCE5ED;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: .28rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.tree_container ul li:first-child{
  border-top:1px solid #DCE5ED;
}
.tree_container ul li:last-child{
  border:0;
}
.title-tr{
  height: .73rem;
  line-height: .73rem;
  vertical-align: middle;
  position: relative;
  margin-left: .13rem;
  display: -webkit-inline-box;
  width: 100%;
}
.title-sub{
  font-size:.24rem;
  font-weight: 400;
  font-family: SourceHanSerifCN-Light;
}
.title-right{
  position:absolute;
  right: .2rem;
}
.icon-down, .icon-up{
  width: .16rem;
  height: .0924rem;
  vertical-align: middle;
}
.title-li{
  width:100%;
  color:#444649;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.title-left{
  width:100%;
  font-size:.28rem;
  font-weight: 600;
  font-family: SourceHanSerifCN-SemiBold;
}
.title-left span{
  display:inline-block;
  width:89%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-wrap:break-word;
}
.children .title-left{
  width:100%;
  font-size:.24rem !important;
  font-weight: 200 !important;
  padding-left:.2rem !important;
  font-family: SourceHanSerifCN-Light;
}
</style>



// WEBPACK FOOTER //
// src/components/treeMenu.vue